import loadable from '@loadable/component'

export default [
  {
    path: '/buyCoin',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BuyCoin-pages-BuyCoins" */ '~/pages/BuyCoin/pages/BuyCoins'
        )
    ),
  },
  {
    path: '/buyCoin/merchantListPage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BuyCoin-pages-MerchantListPage" */ '~/pages/BuyCoin/pages/MerchantListPage'
        )
    ),
  },
  {
    path: '/buyCoin/myOrdersPage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BuyCoin-pages-MyOrdersPage" */ '~/pages/BuyCoin/pages/MyOrdersPage'
        )
    ),
  },
  {
    path: '/buyCoin/orderStatusPage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BuyCoin-pages-OrderStatusPage" */ '~/pages/BuyCoin/pages/OrderStatusPage'
        )
    ),
  },
]
